import { swSettings } from "app/common/services/swSettings";
import { CompetitiveOpportunities } from "./competitive-opportunities/CompetitiveOpportunities";
import { RankingDistributionSection } from "./ranking-distribution/RankingDistribution";
import { SERPOppportunities } from "./serp-opportunities/SERPOpportunities";
import { Summary } from "./summary/Summary";
import { TrafficTrends } from "./traffic-trends/TrafficTrends";

export const SeoOverviewPage = () => {
    return (
        <>
            <Summary />
            <RankingDistributionSection />
            <CompetitiveOpportunities />
            <TrafficTrends />
            <SERPOppportunities />
        </>
    );
};
